import * as React from "react";
import "../../../../assets/scss/components/toc/orderPlacement/generic/opMandateDropdown.scss";
import { Link } from "react-router-dom";

export interface IOpMandateDropdownProps {
	onOptionSelect: (data: IMandateDropdownData) => void;
	dropdownList: Array<IMandateDropdownData>;
}

export interface IMandateDropdownData {
	bankName: string;
	acc: string;
	transactionLimit: string;
	mandateId: number; // mandate id is unique
	isApproved: boolean;
}

export interface IOpMandateDropdownState {
	isDropdownOpen: boolean;
	selectedOption: IMandateDropdownData | null;
}

class OpMandateDropdown extends React.Component<IOpMandateDropdownProps, IOpMandateDropdownState> {
	dropdownListRef = React.createRef<HTMLUListElement>();

	state: IOpMandateDropdownState = {
		isDropdownOpen: false,
		selectedOption: null,
	};

	dropdownEl: any;

	componentDidMount() {
		// select the 0th option by default
		this.setState({ selectedOption: this.props.dropdownList[0] });
	}

	onOptionSelect = (d: IMandateDropdownData) => {
		this.setState({ isDropdownOpen: false, selectedOption: d });
		return this.props.onOptionSelect(d);
	};

	render() {
		return (
			<>
				<div className="op_mandate_dropdown">
					<button className="select_btn" onClick={() => this.setState({ isDropdownOpen: true })}>
						<span>
							{this.state.selectedOption?.bankName} — {this.state.selectedOption?.acc}
						</span>
						<i className="edel-icon-arrow-down" />
					</button>

					{/* Overlay covers the whole screen. When overlay is clicked, close the dropdown. */}
					{this.state.isDropdownOpen && <div className="dropdown_overlay" onClick={() => this.setState({ isDropdownOpen: false })} />}

					<ul className={"dropdown" + (this.state.isDropdownOpen ? " active" : "")} ref={this.dropdownListRef}>
						{/* Dropdown list */}
						{this.props.dropdownList.map(d => (
							<li className="dropdown_item" key={d.mandateId} onClick={() => this.onOptionSelect(d)}>
								<div className="dropdown_data">
									{this.state.selectedOption && <i className={(d === this.state.selectedOption ? "edel-icon-tick " : "") + "tick"}></i>}
									<div className={"dropdown_content" + (d === this.state.selectedOption ? " active" : "")}>
										<div className="row row_1">
											<span className="bankname">{d.bankName}</span>
											<span className="amount">{d.transactionLimit}</span>
										</div>
										<div className="row row_2">
											<span className="bankname">Mandate ID: {d.mandateId}</span>
											<span className="amount">{d.isApproved ? "Approved" : "Non-Approved"}</span>
										</div>
									</div>
								</div>
							</li>
						))}
					</ul>
				</div>

				<div className="add_mandate">
					<Link to="#" className="add_mandate_link">
						<i className="edel-icon-plus" />
						Add New Mandate
					</Link>
				</div>
			</>
		);
	}
}

export default OpMandateDropdown;
